<template>
  <div class="profile">

    <div id="user-menu" class="dropdown">
      <a class="dropdown-toggle" data-toggle="dropdown"><img alt="Avatar" v-bind:src="avatar" class="avatar" /></a>

      <ul class="dropdown-menu">
        <li>
          <a href="/settings/user/personalInformation/">
            <i class="mdi mdi-account"></i> Mijn account
          </a>
        </li>
        <li>
          <a href="/settings/">
            <i class="mdi mdi-settings"></i> Systeeminstellingen
          </a>
        </li>
        <li>
          <a href="/settings/tools/">
            <i class="mdi mdi-toolbox"></i> Tools
          </a>
        </li>
        <li class="divider"></li>
        <li>
          <a href="/auth/logout" id="logout">
            <i class="mdi mdi-power"></i> Uitloggen
          </a>
        </li>
      </ul>

    </div>
  </div>
</template>
<script>
export default {
  name: "ProfileDropdownComponent.vue",
  props: {
    avatar: String,
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.profile {
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: $spacing-xs;
}
.credits {
  height: 100%;
  padding: 0 $spacing-sm;
  border-radius: 9999px;
  border: 1px solid white;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(2, 1fr);
  color: white;
.credits-label {
  margin: auto 0 ;
  font-size: $font-size-small;
  font-weight: 200;
  padding-right: $spacing-sm;
}
.credits-total {
  margin: auto 0;
  font-weight: 600;
  font-size: $font-size-base;
  height: 100%;
  padding-left: $spacing-sm;
  display: grid;
  place-content: center;
  border-left: 1px solid white;
}
}

.avatar {
  max-height: 30px;
  object-fit: cover;
  object-position: center;
  overflow: hidden;
  border-radius: 9999px;
  aspect-ratio: 1/1 ;

}
.dropdown {
  list-style-type: none;
}
.dropdown-menu {
  right: 0;
  left: auto;
  top: auto;
}
</style>
